import { Container } from '@bit/ui-common.ui-components/ss-components';
import * as FsdoContactServices from 'services/fsdo/fsdoContactServices';
import * as FsdoFsdoServices from 'services/fsdo/fsdoFsdoServices';
import FsdoRegistrationLayout from 'components/layouts/FsdoRegistrationLayout';
import { captcha } from '@bit/ui-common.ui-components/ss-common-data';
import { ssFormServices } from '@bit/ui-common.ui-components/ss-utils';
import * as StatusService from 'services/statusService';
import LoginDisabled from './LoginDisabled';

export default Container({
    state: s => ({
        fsdo: s.fsdo || null,
        geo: s.commonData.geoData || null,
        text: s.commonData.textData || null,
        captcha: s.captcha,
        commonData: s.commonData,
        registrationForm: s.registrationForm || null,
        loginStatus: s.status
    }),
    services: [
        FsdoContactServices,
        FsdoFsdoServices,
        captcha.captchaServices,
        ssFormServices,
        StatusService
    ]
},
class FsdoRegistration extends FsdoRegistrationLayout {
    state = {}
    constructor(props) { 
        super(props); 
        const { services } = this.props;
        services.fetchLoginStatus();
    }

    componentDidMount() {
        if(super.componentDidMount) super.componentDidMount();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(super.componentDidUpdate) super.componentDidUpdate(prevProps, prevState, snapshot)
    }

    getSnapshotBeforeUpdate(prevProps, prevState) {
        if(super.getSnapshotBeforeUpdate) return super.getSnapshotBeforeUpdate(prevProps, prevState);
        else return null;
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if(super.getDerivedStateFromProps) return super.getDerivedStateFromProps(nextProps, prevState);
        else return null;
    }

    render() {
        const {loginStatus} = this.props;
        if (loginStatus.nonPivLogin != 'N') {
            return(<div>{super.render() || []}</div>);
        }else {
            return (<LoginDisabled  />);
        }
}})